import React, { useState } from 'react';
import ContactList from './ContactList';

const contacts = [
  { id: 1, name: 'Dr. Sarah Johnson', role: 'Cardiologist', status: 'Available', statusColor: 'green', avatarUrl: '', isInternal: true, isOnline: true },
  { id: 2, name: 'Dr. Michael Chen', role: 'Neurologist', status: 'Busy', statusColor: 'orange', avatarUrl: '', isInternal: true, isOnline: true },
  { id: 3, name: 'Nurse Lisa Rodriguez', role: 'ICU Nurse', status: 'Available', statusColor: 'green', avatarUrl: '', isInternal: true, isOnline: true },
  { id: 4, name: 'Dr. Robert Kim', role: 'Emergency Medicine', status: 'Offline', statusColor: 'red', avatarUrl: '', isInternal: true, isOnline: false },
  { id: 5, name: 'Dr. Amanda White', role: 'Pediatrician', status: 'Available', statusColor: 'green', avatarUrl: '', isInternal: true, isOnline: true },
  // Add external contacts as needed
];

const AddressBook = ({ onSelectContact }) => {
  const [search, setSearch] = useState('');
  const [tab, setTab] = useState('internal');

  const filteredContacts = contacts.filter(c =>
    (tab === 'internal' ? c.isInternal : !c.isInternal) &&
    (c.name.toLowerCase().includes(search.toLowerCase()) || c.role.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 32 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 26, flex: 1, display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ background: '#eaf4ff', borderRadius: 8, padding: 6, fontSize: 20 }}>📒</span>
          Address Book
        </div>
        <button style={{ background: '#1976d2', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 600, fontSize: 16, marginRight: 16, cursor: 'pointer' }}>+ Add Contact</button>
        <span style={{ background: '#f4f6fa', borderRadius: '50%', width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, cursor: 'pointer' }}>👤</span>
      </div>
      <input
        type="text"
        placeholder="Search contacts..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ width: '100%', padding: '12px 16px', border: '1px solid #e3e7ed', borderRadius: 8, fontSize: 16, marginBottom: 24 }}
      />
      <div style={{ display: 'flex', gap: 0, marginBottom: 18 }}>
        <button
          onClick={() => setTab('internal')}
          style={{ flex: 1, padding: '12px 0', fontWeight: 600, fontSize: 16, border: 'none', borderBottom: tab === 'internal' ? '3px solid #1976d2' : '3px solid #f0f0f0', background: tab === 'internal' ? '#fff' : '#f8fafd', color: tab === 'internal' ? '#1976d2' : '#888', cursor: 'pointer' }}
        >
          Internal Contacts
        </button>
        <button
          onClick={() => setTab('external')}
          style={{ flex: 1, padding: '12px 0', fontWeight: 600, fontSize: 16, border: 'none', borderBottom: tab === 'external' ? '3px solid #1976d2' : '3px solid #f0f0f0', background: tab === 'external' ? '#fff' : '#f8fafd', color: tab === 'external' ? '#1976d2' : '#888', cursor: 'pointer' }}
        >
          External Contacts
        </button>
      </div>
      <ContactList contacts={filteredContacts} onSelectContact={onSelectContact} />
    </div>
  );
};

export default AddressBook; 